import { render, staticRenderFns } from "./TipController.vue?vue&type=template&id=803d7a96&scoped=true&"
import script from "./TipController.vue?vue&type=script&lang=ts&"
export * from "./TipController.vue?vue&type=script&lang=ts&"
import style0 from "./TipController.vue?vue&type=style&index=0&id=803d7a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803d7a96",
  null
  
)

export default component.exports